export default {
  SET_CURRENT_LEARNING_PLAN: "SET_CURRENT_LEARNING_PLAN",
  SET_LESSON_CODE: "SET_LESSON_CODE",
  ADD_LESSON_TO_PLAN: "ADD_LESSON_TO_PLAN",
  ADD_AC_CODE_FOR_EDIT: "ADD_AC_CODE_FOR_EDIT",
  SET_CURRENT_SLIDE: "SET_CURRENT_SLIDE",
};
